import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

const routes: Routes = [
	{ path: 'login', loadComponent: async () => import('./pages/login/login.component').then(m => m.LoginComponent) },
	{
		path: 'google-callback',
		loadComponent: async () => import('./pages/google-callback/google-callback.component').then(m => m.GoogleCallbackComponent),
	},
	{ path: 'home', loadComponent: async () => import('./pages/home/home.component').then(m => m.HomeComponent), canActivate: [authGuard] },
	{
		path: 'meal-plan',
		loadComponent: async () => import('./pages/meal-plan/meal-plan2.component').then(m => m.MealPlan2Component),
		canActivate: [authGuard],
	},
	{
		path: 'inventory',
		loadComponent: async () => import('./pages/inventory/inventory.component').then(m => m.InventoryComponent),
		canActivate: [authGuard],
	},
	{
		path: 'measurement-units',
		loadComponent: async () => import('./pages/measurement-units/measurement-units.component').then(m => m.MeasurementUnitsComponent),
		canActivate: [authGuard],
	},
	{
		path: 'consumables',
		loadComponent: async () => import('./pages/consumables-page/consumable-page.component').then(m => m.ConsumablePageComponent),
		canActivate: [authGuard],
	},
	{
		path: 'recipes',
		loadComponent: async () => import('./pages/recipes-page/recipes-page.component').then(m => m.RecipesPageComponent),
		canActivate: [authGuard],
	},
	{
		path: 'family-editor',
		loadComponent: async () => import('./pages/family-editor/family-editor.component').then(m => m.FamilyEditorComponent),
		canActivate: [authGuard],
	},
	{
		path: 'store-products',
		loadComponent: async () => import('./pages/store-products-page/store-products-page.component').then(m => m.StoreProductsPageComponent),
		canActivate: [authGuard],
	},
	{
		path: 'shopping-list',
		loadComponent: async () => import('./pages/shopping-list/shopping-list.component').then(m => m.ShoppingListComponent),
		canActivate: [authGuard],
	},
	{
		path: 'meals',
		loadComponent: async () => import('./pages/meals-page/meals-page.component').then(m => m.MealsPageComponent),
		canActivate: [authGuard],
	},
	{ path: '', redirectTo: '/home', pathMatch: 'full' },
	{ path: '**', redirectTo: '/home', pathMatch: 'full' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {})],
	exports: [RouterModule],
})
// Angular routing modules are intentionally empty shells.
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AppRoutingModule {}
